
import Vue, { PropType } from 'vue'
import Image from '@/models/Image'

import PlantAvatar from '@/ui/components/plants/PlantAvatar.vue'
import JImageCarousel from '@/ui/controls/JImageCarousel.vue'

// import { getStorageUrlSize } from '@/helpers/paths'

import { sortItemsByTimestamps } from '@/helpers/sorters'
import { id } from '@/types/models'
import { RawLocation } from 'vue-router'
import { ImageDimensions } from '../../models/Imagable'

type NumberOrUndefined = number | undefined

type ImageSize = 's' | 'm' | 'l'

const DEFAULT_ROUTE = 'gardens'

export default Vue.extend({
  components: {
    PlantAvatar,
    JImageCarousel,
  },
  props: {
    images: Array as PropType<Array<Image>>,
    // imageId: String,
    imageSize: {
      type: String as PropType<ImageSize>,
      default: 'm' as ImageSize,
    },
    // size: {
    //   type: Number,
    //   default: 200,
    // },
    sort: {
      type: Function as PropType<() => number>,
      default: () => sortItemsByTimestamps,
    },
    showPlants: Boolean,

    cols: {
      type: [String, Number],
      // default: '6',
      // default: undefined,
      default: 'auto',
    },
    sm: {
      type: [String, Number],
      // default: '4',
      default: undefined,
    },
    md: {
      type: [String, Number],
      // default: '3',
      default: undefined,
    },
    lg: {
      type: [String, Number],
      // default: '3',
      default: undefined,
    },
    xl: {
      type: [String, Number],
      // default: '3',
      default: undefined,
    },

    imgWidth: {
      type: [String, Number],
      default: undefined,
    },
    imgHeight: {
      type: [String, Number],
      default: undefined,
    },

    nestedGrid: Boolean,
    outlined: Boolean,
  },
  data: () => ({
    imageId: undefined as string | undefined,
    // dialog: undefined as NumberOrUndefined,
    // drawer: false,
    fullscreenCarousel: false,
  }),
  computed: {
    showDialog(): boolean {
      return !!this.imageId && this.containsImage
      // return !!this.imageId // && this.containsImage
    },
    containsImage(): boolean {
      return this.images.some((image) => image.id === this.imageId)
    },
  },
  created() {
    // console.log(this.images)
  },
  methods: {
    closeDialog() {
      // this.$router.push(this.getImageRoute());
      this.imageId = undefined
    },
    onCarouselChange(v: id): void {
      // console.log('onCarouselChange', v)
      this.$router.push(this.getImageRoute(v))
    },
    getImageRoute(imageId?: id): RawLocation {
      return {
        name: this.$route.name || DEFAULT_ROUTE,
        params: Object.assign({}, this.$route.params, { imageId: imageId }),
      }
    },
    imgMaxWidthHeight(dimensions: ImageDimensions) {
      return dimensions.height > dimensions.width
        ? dimensions.height
        : dimensions.width
    },
    // getSize(url: string, size: number | string) {
    //   return size ? getStorageUrlSize(url, size) : url
    // },
    // next() {
    //   this.dialog = Math.min(this.images.length - 1, (this.dialog || -1) + 1)
    // },
  },
})
